import {
  CreateEmptyFieldGroupOnRecordSettingsMutation,
  CreateEmptyFieldGroupOnRecordSettingsMutationVariables,
  ResetRecordSettingsInspectionAvailabilityWindowsMutation,
  ResetRecordSettingsInspectionAvailabilityWindowsMutationVariables,
  SetRecordSettingsMutation,
  SetRecordSettingsMutationVariables,
} from 'types/graphql'

import { useMutation } from 'src/utils/queryClient'

const SetRecordSettings = gql`
  mutation SetRecordSettingsMutation(
    $connection: ConfigConnectionInput!
    $settings: RecordSettingsInput!
  ) {
    setRecordSettings(connection: $connection, settings: $settings) {
      __typename
    }
  }
`
export const useSetRecordSettingsMutation = () => {
  return useMutation<SetRecordSettingsMutation, SetRecordSettingsMutationVariables>({
    mutationDocument: SetRecordSettings,
  })
}

const CreateEmptyFieldGroupOnRecordSettings = gql`
  mutation CreateEmptyFieldGroupOnRecordSettingsMutation(
    $input: CreateEmptyFieldGroupOnRecordSettingsInput!
  ) {
    fieldGroupOnRecordSettings: createEmptyFieldGroupOnRecordSettings(input: $input) {
      ...FieldGroupOnRecordSettingsFragment
    }
  }
`
export const useCreateEmptyFieldGroupOnRecordSettingsMutation = () => {
  return useMutation<
    CreateEmptyFieldGroupOnRecordSettingsMutation,
    CreateEmptyFieldGroupOnRecordSettingsMutationVariables
  >({
    mutationDocument: CreateEmptyFieldGroupOnRecordSettings,
  })
}

const ResetRecordSettingsInspectionAvailabilityWindows = gql`
  mutation ResetRecordSettingsInspectionAvailabilityWindowsMutation(
    $connection: ConfigConnectionInput!
  ) {
    resetRecordSettingsInspectionAvailabilityWindows(connection: $connection)
  }
`

export const useResetRecordSettingsInspectionAvailabilityWindowsMutation = () => {
  return useMutation<
    ResetRecordSettingsInspectionAvailabilityWindowsMutation,
    ResetRecordSettingsInspectionAvailabilityWindowsMutationVariables
  >({
    mutationDocument: ResetRecordSettingsInspectionAvailabilityWindows,
  })
}
